import React from 'react';
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput, DateInput, required } from 'react-admin';
import { coreWalletVatTypesForSelection } from './VatDefinitionConstants';
import PropTypes from 'prop-types';
import { countriesForSelection } from '../../i18n/en.js';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';

const subsidiaryRenderer = choice => `${choice.id}: ${choice.name}`;

const VatDefinitionCreate = ({
	vatTypesForSelection,
	...props
}) => (
	<Create {...props}>
		<SimpleForm>
			<ReferenceInput source="subsidiaryId" reference="subsidiaries" validate={required()}>
				<SelectInput optionText={subsidiaryRenderer} />
			</ReferenceInput>
			<SelectInput choices={vatTypesForSelection} source="vatType" resettable validate={required()} />
			<SelectInput choices={countriesForSelection} source="countryCode" resettable validate={required()} />
			<TextInput source="vatRate" resettable validate={required()} />
			<DateInput
				alwaysOn
				source="validFrom"
				parse={value => toApiDateTimeFormat(value)}
				format={value => toJavaScriptDateFormat(value)}
				validate={required()}
			/>
			<TextInput source="description" resettable />
		</SimpleForm>
	</Create>
);

VatDefinitionCreate.propTypes = {
	vatTypesForSelection: PropTypes.array.isRequired
};
VatDefinitionCreate.defaultProps = {
	vatTypesForSelection: coreWalletVatTypesForSelection
};

export default VatDefinitionCreate;
